import { render, staticRenderFns } from "./dePosit.vue?vue&type=template&id=00725364&scoped=true"
import script from "./dePosit.vue?vue&type=script&lang=js"
export * from "./dePosit.vue?vue&type=script&lang=js"
import style0 from "./dePosit.vue?vue&type=style&index=0&id=00725364&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00725364",
  null
  
)

export default component.exports